import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {UfTopicSeverityEnum} from "../enum/uf-topic-severity.enum";
import {UfTopicStatusEnum} from "../enum/uf-topic-status.enum";

export class UfFlowTopicDto extends DtoDetail {

    public flowDtoId: number;
    public flowDtoName: string;

    public flowStepDtoId: number;
    public flowStepDtoName: string;

    public resolutionStepDtoId: number;
    public resolutionStepDtoName: string;

    public topicRuleDtoId: number;
    public topicRuleDtoName: string;

    public description: string;

    public severity: UfTopicSeverityEnum;
    public status: UfTopicStatusEnum;

    public relatedFlowObjectDtoId: number;
    public relatedFlowObjectDtoName: string;

    public resolvedAt: Date;
    public resolutionNote: string;

    public escalated: boolean;
    public escalationTicketDtoId: number;
    public escalationTicketDtoName: string;
}
